module.exports = __webpack_public_path__ + "media/bootstrap-icons/file-earmark-excel-fill-7ea88f9a.svg";